import styled from '@emotion/styled'
import { Theme } from '@yuno/design-system-web'

type StyledProps = { theme?: Theme }

type ConnectionCardProps = {
  textLeft: string
  textRight: string
  child?: JSX.Element
}

const Container = styled('div')<StyledProps>`
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  background-color: white;
  border-radius: 4px;
`

const GridStyled = styled('div')<StyledProps>`
  display: flex;
  margin-top: 20px;
`

const TitleContainer = styled('div')`
  flex: 1;
`

const Title = styled('p')<StyledProps>`
  color: ${({ theme }) => theme.palette.neutral.black};
  font-size: 16px;
  display: inline-block;
  margin: 0px;
  margin-left: 20px;
`

const CategoryContainer = styled('div')`
  margin-right: 20px;
`

const CategoryText = styled('p')<StyledProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: start;
  color: ${({ theme }) => theme.palette.grey[5]};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  font-family: ${({ theme }) => theme.typography.tiny.regular.fontFamily};
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 6px;
  padding-right: 6px;
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  border-radius: 4px;
  margin: 0px;
`

const Hr = styled('hr')<StyledProps>`
  width: 100%;
  height: 0px;
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  margin-top: 20px;
`

const ConnectionSection = ({
  textLeft,
  textRight,
  child,
}: ConnectionCardProps) => {
  return (
    <Container>
      <GridStyled>
        <TitleContainer>
          <Title>{textLeft}</Title>
        </TitleContainer>
        {textRight && (
          <CategoryContainer>
            <CategoryText>{textRight}</CategoryText>
          </CategoryContainer>
        )}
      </GridStyled>
      <Hr />
      {child}
    </Container>
  )
}

export default ConnectionSection
